export default __webpack_public_path__ + "static/media/qr_code.e2cce2b0.png";